import { GlobalEvents } from 'modules/global';
import { State, Store } from 'store/types';
import { FETCH_SERVICE_LIST } from 'modules/services';
import { FETCH_SHOP_LIST } from 'modules/shops';
import { initWidgetData } from './init-widget-data';

export const initWidgetDataWithShops = (state: State): Store => {
  const store = initWidgetData(state);

  store.dispatch(GlobalEvents.setRequestParams, {
    orchestratorHost: state.orchestratorHost,
  });
  store.dispatch(FETCH_SHOP_LIST.success, state.shops?.shopList ?? undefined);
  store.dispatch(FETCH_SERVICE_LIST.success, state.services?.serviceList ?? undefined);

  return store;
};
